/* unplugin-vue-components disabled */import { render } from "./fieldstruct.vue?vue&type=template&id=627968d1"
import script from "./fieldstruct.vue?vue&type=script&lang=js"
export * from "./fieldstruct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__